import Modal from './Modal';
import SignInWithGoogleButton from './SignInWithGoogleButton';
import SignInWithEmailButton from './SignInWithEmailButton';

interface WelcomeModalProps {
  onDismiss: () => void;
}

// Detect in-app browsers (Twitter, Facebook, Instagram, etc.)
function isInAppBrowser(): boolean {
  const ua = navigator.userAgent || navigator.vendor;
  return /FBAN|FBAV|Instagram|Twitter|Line|Snapchat|WeChat|MicroMessenger/i.test(
    ua
  );
}

const buttonStyle = {
  height: '40px',
  minWidth: '280px',
  borderRadius: '20px',
  cursor: 'pointer',
  fontFamily: "'Roboto', arial, sans-serif",
  fontSize: '14px',
  fontWeight: 500,
  padding: '0 12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  border: 'none',
} as const;

const WelcomeModal = ({ onDismiss }: WelcomeModalProps) => {
  const inWebview = isInAppBrowser();

  return (
    <Modal>
      <h2
        style={{
          color: 'var(--gold)',
          marginBottom: '1rem',
          fontSize: '1.5rem',
        }}
      >
        Welcome to Earmark
      </h2>
      <p style={{ color: 'var(--primary)', marginBottom: '1.5rem' }}>
        Turn articles and essays into audio for your commute.
      </p>

      {inWebview && (
        <p
          style={{
            color: 'var(--gold)',
            marginBottom: '1rem',
            fontSize: '14px',
            padding: '0.75rem',
            background: 'rgba(var(--gold-rgb), 0.1)',
            borderRadius: '8px',
          }}
        >
          For full access, open this page in Safari or Chrome
        </p>
      )}

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '0.75rem',
        }}
      >
        {!inWebview && <SignInWithGoogleButton />}
        <SignInWithEmailButton
          buttonStyle={{
            ...buttonStyle,
            backgroundColor: 'var(--accent)',
            color: 'white',
          }}
        />
        <button
          onClick={onDismiss}
          style={{
            ...buttonStyle,
            backgroundColor: 'transparent',
            border: '1px solid var(--border)',
            color: 'var(--primary)',
          }}
        >
          Continue as Guest
        </button>
      </div>
    </Modal>
  );
};

export default WelcomeModal;
